<mat-toolbar
  color="primary"
  fxLayout="row"
  fxLayoutAlign="start center"
  class="mat-elevation-z4"
>
  <div fxFlex="10">
    <button
      type="button"
      id="sidenavbutton"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="toggleSideNavBar()"
    >
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
  </div>
  <div
    fxFlexOffset="25"
    fxFlex="30"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <img class="header-image" routerLink="/" src="{{ uVuyoImage$ | async }}" />
  </div>
  <div fxFlex fxLayout="row" fxLayoutAlign="end center">
    <app-unauthenticated-user-menu
      *ngIf="(identity.userLoggedIn$ | async) === false"
    ></app-unauthenticated-user-menu>
    <app-user-menu
      *ngIf="(identity.userLoggedIn$ | async) === true"
    ></app-user-menu>
  </div>
</mat-toolbar>
